(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const observeInview = (root) => {
    if (!root || root.classList.contains("si26-is-inview")) return;

    if (reduceMotion.matches || typeof IntersectionObserver === "undefined") {
      root.classList.add("si26-is-inview");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("si26-is-inview");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(root);
  };

  const getStickyOffset = () => {
    if (window.si26Sticky?.getScrollOffset) {
      return window.si26Sticky.getScrollOffset();
    }
    const nav = document.querySelector("[data-si26-nav]");
    const header = document.querySelector(".site-header");
    const chrome = header ? Math.round(header.getBoundingClientRect().top + header.offsetHeight) : 0;
    if (nav) return Math.max(0, chrome + Math.round(nav.offsetHeight || 0));
    return Math.max(0, chrome);
  };

  const resolveTarget = (target) => {
    if (window.si26Sticky?.resolveScrollElement) {
      return window.si26Sticky.resolveScrollElement(target) || target;
    }
    return (
      target.querySelector("[data-si26-pin]") ||
      target.querySelector("[data-si26-sticky]") ||
      target.querySelector(".si26-lottery__inner") ||
      target
    );
  };

  const measureTop = (target) => {
    const el = resolveTarget(target);
    return Math.max(0, window.scrollY + el.getBoundingClientRect().top - getStickyOffset() + 1);
  };

  const scrollToHash = (hash) => {
    if (!hash || hash === "#") return false;
    const target = document.querySelector(hash);
    if (!target) return false;

    const useSmooth = !reduceMotion.matches;
    let settleStarted = false;

    const runSettle = () => {
      if (settleStarted) return;
      settleStarted = true;
      let passes = 0;
      const tick = () => {
        window.scrollTo({ top: measureTop(target), behavior: "auto" });
        passes += 1;
        if (passes < 24) window.requestAnimationFrame(tick);
      };
      window.requestAnimationFrame(tick);
    };

    window.scrollTo({
      top: measureTop(target),
      behavior: useSmooth ? "smooth" : "auto"
    });

    if (useSmooth && "onscrollend" in window) {
      window.addEventListener("scrollend", runSettle, { once: true });
      window.setTimeout(runSettle, 1400);
    } else {
      window.setTimeout(runSettle, useSmooth ? 700 : 32);
    }
    return true;
  };

  const initHero = (root) => {
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    observeInview(root);

    root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", (event) => {
        const hash = anchor.getAttribute("href");
        if (!scrollToHash(hash)) return;
        event.preventDefault();
        if (hash && history.replaceState) {
          history.replaceState(null, "", hash);
        }
      });
    });
  };

  const init = (scope = document) => {
    if (scope.matches?.("[data-si26-hero]")) {
      initHero(scope);
    }
    scope.querySelectorAll?.("[data-si26-hero]").forEach(initHero);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
